// src/services/aiConsumptionService.js
// Superadmin AI consumption journal client.
// Backend: GET /api/ai-consumption, /summary, /export (superadmin only).
import api from '../api/apiClient';

const normalizePagination = (pagination = {}) => ({
  page: pagination.currentPage || pagination.page || 1,
  limit: pagination.limit || 20,
  total: pagination.total || 0,
  pages: pagination.pages || 0,
});

export const aiConsumptionService = {
  // Paginated journal rows (same { success, data, pagination } shape as logService)
  getConsumption: async (filters = {}) => {
    try {
      const response = await api.get('/ai-consumption', filters);
      if (response && response.pagination) {
        return { ...response, pagination: normalizePagination(response.pagination) };
      }
      return response;
    } catch (error) {
      console.error('Get AI consumption API error:', error);
      throw error;
    }
  },

  // Aggregated totals for cards + charts
  getSummary: async (filters = {}) => {
    try {
      return await api.get('/ai-consumption/summary', filters);
    } catch (error) {
      console.error('Get AI consumption summary API error:', error);
      throw error;
    }
  },

  // CSV export (blob) with the same filters as the list.
  // Uses api.download (responseType blob) — api.get drops that option.
  exportCsv: async (filters = {}) => {
    try {
      const blob = await api.download('/ai-consumption/export', filters);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Ebiosens_AI_Consumption_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Export AI consumption API error:', error);
      throw error;
    }
  }
};

export const AI_OPERATION_LABELS = {
  chatbot: 'Chatbot',
  'w1-dreaded-events': 'A1 · Événements redoutés',
  'w1-security-controls': 'A1 · Mesures de sécurité',
  'w1-security-controls-batch': 'A1 · Mesures (lot)',
  'w2-sources-risque': 'A2 · Sources de risque',
  'w3-ecosystem-measures': 'A3 · Mesures écosystème',
  'w4-scenarios-v2': 'A4 · Scénarios V2',
  'w4-checklist-questions': 'A4 · Questions checklist',
  'w4-rule-match': 'A4 · Appariement règle',
  'w4-rule-match-batch': 'A4 · Appariement (lot)',
  'w5-residual-risk': 'A5 · Risque résiduel',
  'w4-pentest-findings': 'A4 · Findings pentest',
  'w4-network-diagram': 'A4 · Schéma réseau',
  'w4-mode-operatoire': 'A4 · Mode opératoire',
  'w4-compare-modes': 'A4 · Comparaison modes',
  'w5-checklist-questions': 'A5 · Questions checklist',
  'report-synthesis': 'Rapport · Synthèse',
  embedding: 'Embedding'
};

export default aiConsumptionService;
